function n(r) {
  var t = r.number, e = r.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(e ? ";ext=" + e : "");
}
export {
  n as formatRFC3966
};
//# sourceMappingURL=design-system.es924.js.map
